import React from 'react';

type State = 'idle' | 'recording' | 'processing' | 'playing' | 'error';

interface Props {
  state: State;
  onPressStart: () => void;
  onPressEnd: () => void;
}

const LABELS: Record<State, string> = {
  idle: 'Hold to record',
  recording: 'Release to send',
  processing: 'Processing...',
  playing: 'Playing...',
  error: 'Error — try again',
};

export function RecorderButton({ state, onPressStart, onPressEnd }: Props) {
  const isActive = state === 'recording';
  const isDisabled = state === 'processing' || state === 'playing';

  return (
    <div style={styles.wrapper}>
      <button
        style={{
          ...styles.button,
          ...(isActive ? styles.active : {}),
          ...(isDisabled ? styles.disabled : {}),
        }}
        onMouseDown={isDisabled ? undefined : onPressStart}
        onMouseUp={isDisabled ? undefined : onPressEnd}
        onTouchStart={isDisabled ? undefined : (e) => { e.preventDefault(); onPressStart(); }}
        onTouchEnd={isDisabled ? undefined : (e) => { e.preventDefault(); onPressEnd(); }}
        disabled={isDisabled}
      >
        {isActive ? (
          <span style={styles.pulse}>⏹</span>
        ) : state === 'processing' ? (
          <span style={styles.spin}>⚙</span>
        ) : state === 'playing' ? (
          '🔊'
        ) : (
          '🎙'
        )}
      </button>
      <span style={styles.label}>{LABELS[state]}</span>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    padding: '16px 0',
  },
  button: {
    width: 72,
    height: 72,
    borderRadius: '50%',
    border: '3px solid #4f46e5',
    background: '#fff',
    fontSize: 28,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.15s',
    userSelect: 'none',
    WebkitUserSelect: 'none',
  },
  active: {
    background: '#4f46e5',
    transform: 'scale(1.1)',
    boxShadow: '0 0 0 8px rgba(79,70,229,0.2)',
  },
  disabled: {
    opacity: 0.5,
    cursor: 'default',
    borderColor: '#aaa',
  },
  pulse: { animation: 'pulse 1s infinite' },
  spin: { display: 'inline-block', animation: 'spin 1s linear infinite' },
  label: { fontSize: 13, color: '#666' },
};
